export default [
	{ "text": "职位维护", "icon": "el-icon-s-claim", "path": "/Job" },
	{ "text": "职位申请", "icon": "el-icon-s-claim", "path": "/Applicant" },
]